(() => {
  const root = document.querySelector('[data-water-tank-controller="true"]');
  if (!root || root.dataset.waterTankControllerBound === 'true') return;
  root.dataset.waterTankControllerBound = 'true';

  const expectedProductId = String(root.dataset.productId || '');
  const optionNamesElement = root.querySelector('.wt-option-names');
  const variantDataElement = root.querySelector('.wt-variant-data');
  if (!optionNamesElement || !variantDataElement) {
    console.error('[Water Tank] Missing contextual option or variant data.');
    return;
  }

  let optionNames;
  let variants;
  try {
    optionNames = JSON.parse(optionNamesElement.textContent);
    variants = JSON.parse(variantDataElement.textContent);
  } catch (error) {
    console.error('[Water Tank] Unable to parse contextual variant data.', error);
    return;
  }

  const colorIndex = optionNames.indexOf('Color');
  const modelIndex = optionNames.indexOf('Model Compatibility');
  if (colorIndex < 0 || modelIndex < 0) {
    console.error('[Water Tank] Required Shopify options were not found.', optionNames);
    return;
  }

  variants = variants
    .map((variant) => ({
      ...variant,
      id: String(variant.id),
      productId: String(variant.productId),
      available: Boolean(variant.available),
      rawOptions: Array.isArray(variant.rawOptions) ? [...variant.rawOptions] : [],
      price: Number(variant.price || 0),
      compareAtPrice: Number(variant.compareAtPrice || 0),
      inventoryQuantity: Number(variant.inventoryQuantity || 0),
    }))
    .filter((variant) => variant.productId === expectedProductId);

  if (variants.length === 0) {
    console.error('[Water Tank] No contextual variants belong to the current product.');
    return;
  }

  const modelOptions = Array.from(root.querySelectorAll('.wt-model-option'));
  const colorOptionsHost = root.querySelector('.wt-color-options');
  const modelValue = root.querySelector('.opts-val-model');
  const colorValue = root.querySelector('.opts-val-color');
  let state = null;

  const displayModel = (rawModel) => String(rawModel || '').replace(/^For\s+/, '');
  const variantModel = (variant) => variant.rawOptions[modelIndex];
  const variantColor = (variant) => variant.rawOptions[colorIndex];
  const galleryKey = (variant) => `${variantModel(variant)}::${variantColor(variant)}`;
  const byId = (variantId) => variants.find((variant) => variant.id === String(variantId));
  const byCombination = (model, color) =>
    variants.find((variant) => variantModel(variant) === model && variantColor(variant) === color);

  const createState = (variant) => ({
    productId: expectedProductId,
    variantId: variant.id,
    rawOptions: [...variant.rawOptions],
    model: variantModel(variant),
    color: variantColor(variant),
    available: variant.available,
    sku: variant.sku || '',
    price: variant.price,
    compareAtPrice: variant.compareAtPrice,
    galleryKey: galleryKey(variant),
  });

  const setHidden = (element, hidden) => {
    if (!element) return;
    element.classList.toggle('d-none', hidden);
    element.hidden = hidden;
  };

  const updatePrice = (variant) => {
    root.querySelectorAll('.price-it-1, .as-product-price').forEach((element) => {
      element.textContent = variant.priceFormatted;
    });

    const hasCompareAt = variant.compareAtPrice > variant.price;
    root.querySelectorAll('.price-it-2, .as-product-compare-at-price').forEach((element) => {
      element.textContent = variant.compareAtPriceFormatted || '';
      const wrapper = element.closest('.price-full-format-2') || element;
      wrapper.classList.toggle('d-none', !hasCompareAt);
    });

    const discount = Math.max(0, variant.compareAtPrice - variant.price);
    root.querySelectorAll('.price-it-3').forEach((element) => {
      element.textContent = (discount / 100).toFixed(2);
      element.closest('.price-full-format-3')?.classList.toggle('d-none', discount <= 0);
    });

    const bottomLoader = root.querySelector('.pb-bottom-loader');
    if (bottomLoader) {
      bottomLoader.dataset.np = String(variant.price);
      bottomLoader.dataset.npm = variant.priceFormatted;
      bottomLoader.dataset.cp = String(variant.compareAtPrice || 0);
      bottomLoader.dataset.cpm = variant.compareAtPriceFormatted || '';
    }
  };

  const updateForms = (variant) => {
    root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dataset.productId = expectedProductId;
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      form.querySelectorAll('#as-inventory-quantity').forEach((input) => {
        input.value = String(variant.inventoryQuantity);
      });

      const submit = form.querySelector('button[name="add"]');
      if (submit) submit.disabled = !variant.available;

      form.querySelectorAll('.as-available-info').forEach((element) => setHidden(element, !variant.available));
      form.querySelectorAll('.as-unavailable-info').forEach((element) => setHidden(element, variant.available));
      form.querySelectorAll('.as-notify-me-btn').forEach((element) => setHidden(element, variant.available));
      form.querySelectorAll('.as-buy-now-btn, .additional-checkout-buttons').forEach((element) => {
        element.classList.toggle('d-none', !variant.available);
      });

      form.querySelectorAll('a.as-checkout-btn[data-cart-url]').forEach((link) => {
        const quantity = form.querySelector('input[name="quantity"]')?.value || '1';
        link.href = `${link.dataset.cartUrl}/${variant.id}:${quantity}`;
        link.classList.toggle('d-none', !variant.available);
        link.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      });
    });

    root.querySelectorAll('input[name="items[0][id]"]').forEach((input) => {
      input.value = variant.id;
      input.dataset.productId = expectedProductId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const addButton = root.querySelector('.my-add-cart-btn');
    const soldOut = root.querySelector('.my-inventory-0');
    addButton?.classList.toggle('super-hidden', !variant.available);
    if (soldOut) {
      soldOut.classList.toggle('super-hidden', variant.available);
      soldOut.textContent = 'Sold Out';
      soldOut.setAttribute('aria-disabled', 'true');
    }

    const deliveryMessage = root.querySelector('amazon-delivery-message');
    if (deliveryMessage) {
      deliveryMessage.setAttribute('product-external-id', `gid://shopify/ProductVariant/${variant.id}`);
    }
  };

const swatchColor = (color) => {
  if (color === 'Blue') return '#657db5';
  if (color === 'Pink') return '#e9b4bd';
  return '#f4f4f4';
};

const useImageSwatches =
  colorOptionsHost?.dataset.useImageSwatch === 'true';

const swatchImages = {
  blue: colorOptionsHost?.dataset.imageBlue || '',
  pink: colorOptionsHost?.dataset.imagePink || '',
  ultraTransparent:
    colorOptionsHost?.dataset.imageUltraTransparent || '',
  neosTransparent:
    colorOptionsHost?.dataset.imageNeosTransparent || '',
};

const swatchImage = (model, color) => {
  if (!useImageSwatches) return '';

  if (color === 'Blue') {
    return swatchImages.blue;
  }

  if (color === 'Pink') {
    return swatchImages.pink;
  }

  if (color === 'Transparent' && model === 'For NEOS II Ultra') {
    return swatchImages.ultraTransparent;
  }

  if (color === 'Transparent' && model === 'For NEOS II') {
    return swatchImages.neosTransparent;
  }

  return '';
};

const swatchMarkup = (model, color) => {
  const image = swatchImage(model, color);

  if (image) {
    return `
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="46.78"
        height="46.78"
        viewBox="-1 -1 50 50"
        class="inner-circle"
      >
        <circle
          class="first-circle"
          cx="23.39"
          cy="23.39"
          r="23.39"
          fill="white"
          stroke="black"
        ></circle>
        <image
          href="${image}"
          x="3.39"
          y="3.39"
          width="40"
          height="40"
          preserveAspectRatio="xMidYMid slice"
        ></image>
      </svg>
    `;
  }

  return `
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="46.78"
      height="46.78"
      viewBox="-1 -1 50 50"
      class="inner-circle"
    >
      <circle
        class="first-circle"
        cx="23.39"
        cy="23.39"
        r="23.39"
        fill="white"
        stroke="black"
      ></circle>
      <circle
        cx="23.39"
        cy="23.39"
        r="20"
        fill="${swatchColor(color)}"
        stroke="#aaaaaa"
      ></circle>
    </svg>
  `;
};

  const renderColors = (activeState) => {
    if (!colorOptionsHost) return;
    const colors = [];
    variants.forEach((variant) => {
      if (variantModel(variant) !== activeState.model) return;
      const color = variantColor(variant);
      if (!colors.includes(color)) colors.push(color);
    });

    const fragment = document.createDocumentFragment();
    colors.forEach((color) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `vs-opt-item wt-color-option${color === activeState.color ? ' selected' : ''}`;
      button.dataset.value = color;
      button.setAttribute('aria-label', color);
      button.setAttribute('aria-pressed', color === activeState.color ? 'true' : 'false');
      button.innerHTML = swatchMarkup(activeState.model, color);
      button.addEventListener('click', () => {
        const variant = byCombination(state.model, color);
        if (!variant) {
          console.error(`[Water Tank] No contextual variant exists for ${state.model} + ${color}.`);
          return;
        }
        applyVariant(variant, { historyMode: 'push', source: 'color' });
      });
      fragment.appendChild(button);
    });
    colorOptionsHost.replaceChildren(fragment);
  };

  const updateSelectors = (activeState) => {
    if (modelValue) modelValue.textContent = displayModel(activeState.model);
    if (colorValue) colorValue.textContent = activeState.color;
    modelOptions.forEach((button) => {
      const selected = button.dataset.modelRaw === activeState.model;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected) button.dataset.targetVariant = activeState.variantId;
    });
    renderColors(activeState);
  };

  const updateSku = (activeState) => {
    root.dataset.currentSku = activeState.sku;
    root.querySelectorAll('[data-product-sku]').forEach((element) => {
      element.textContent = activeState.sku;
    });
  };

  const updateUrl = (variantId, historyMode) => {
    if (historyMode === 'none') return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    const method = historyMode === 'replace' ? 'replaceState' : 'pushState';
    window.history[method]({ waterTankVariantId: variantId }, '', url);
  };

  const notifyGallery = (activeState) => {
    const detail = { galleryKey: activeState.galleryKey, state: activeState };
    document.querySelector('.wt-product-gallery')?.dispatchEvent(
      new CustomEvent('water-tank:gallery-change', { detail }),
    );
  };

  const applyVariant = (variant, { historyMode = 'push', source = 'user' } = {}) => {
    if (!variant || variant.productId !== expectedProductId) {
      console.error('[Water Tank] Refused a variant outside the current product.', variant);
      return false;
    }
    state = createState(variant);
    root.dataset.canonicalVariantId = state.variantId;
    root.dataset.canonicalGalleryKey = state.galleryKey;
    root.dataset.variantAvailable = String(state.available);
    updateSelectors(state);
    updatePrice(variant);
    updateForms(variant);
    updateSku(state);
    updateUrl(state.variantId, historyMode);
    notifyGallery(state);
    document.dispatchEvent(new CustomEvent('water-tank:variant-change', { detail: { state: { ...state }, source } }));
    return true;
  };

  modelOptions.forEach((button) => {
    button.addEventListener('click', () => {
      const model = button.dataset.modelRaw;
      if (!model || model === state?.model) return;
      const candidates = variants.filter((variant) => variantModel(variant) === model);
      const nextVariant = candidates.find((variant) => variantColor(variant) === state?.color) || candidates[0];
      if (!nextVariant) {
        console.error(`[Water Tank] No contextual variants exist for ${model}.`);
        return;
      }
      applyVariant(nextVariant, { historyMode: 'push', source: 'model' });
    });
  });

  root.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[data-type="add-to-cart-form"]')) return;
      const submittedVariantId = String(form.querySelector('input[name="id"]')?.value || '');
      const submittedProductId = String(form.querySelector('input[name="id"]')?.dataset.productId || '');
      if (!state?.available || submittedVariantId !== state.variantId || submittedProductId !== expectedProductId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        console.error('[Water Tank] Blocked an invalid add-to-cart submission.', {
          canonicalVariantId: state?.variantId,
          submittedVariantId,
          expectedProductId,
          submittedProductId,
          available: state?.available,
        });
      }
    },
    true,
  );

  const customAddButton = root.querySelector('.my-add-cart-btn');
  customAddButton?.addEventListener('click', () => {
    if (!state?.available) return;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const submit = form?.querySelector('button[name="add"]');
    if (submit && !submit.disabled) submit.click();
  });

  const quantityInput = document.querySelector('.quantity-selector-wrapper input[name="quantity"]');
  const syncQuantity = () => {
    if (!quantityInput || !state) return;
    const quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
    root.querySelectorAll('form[data-type="add-to-cart-form"] input[name="quantity"]').forEach((input) => {
      input.value = String(quantity);
    });
    root.querySelectorAll('a.as-checkout-btn[data-cart-url]').forEach((link) => {
      link.href = `${link.dataset.cartUrl}/${state.variantId}:${quantity}`;
    });
  };
  quantityInput?.addEventListener('input', syncQuantity);
  quantityInput?.addEventListener('change', syncQuantity);

  window.addEventListener('popstate', () => {
    const requestedVariant = new URL(window.location.href).searchParams.get('variant');
    const variant = byId(requestedVariant);
    if (variant) applyVariant(variant, { historyMode: 'none', source: 'popstate' });
  });

  const urlVariant = byId(new URL(window.location.href).searchParams.get('variant'));
  const liquidVariant = byId(root.dataset.initialVariantId);
  const initialVariant = urlVariant || liquidVariant || variants[0];
  applyVariant(initialVariant, { historyMode: 'replace', source: 'initial' });
  syncQuantity();

  window.WaterTank2026new = Object.freeze({
    productId: expectedProductId,
    getState: () => (state ? { ...state, rawOptions: [...state.rawOptions] } : null),
    getVariants: () => variants.map((variant) => ({ ...variant, rawOptions: [...variant.rawOptions] })),
  });
})();
